export default __webpack_public_path__ + "static/media/doctor-res-btn.ddf5bec2.svg";